// extracted by mini-css-extract-plugin
export default {"filter":"VoiceCardsContainer_filter__AB2YS","cont":"VoiceCardsContainer_cont__P6dti","cards":"VoiceCardsContainer_cards__v6YCn","search":"VoiceCardsContainer_search__1EZu-"};